import React, { useEffect } from "react";
import M from "materialize-css";
import "../css/HeaderSecundario.css";
import { Link } from "react-router-dom";

export default function HeaderSecundario(props) {
  useEffect(() => {
    var elems = document.querySelectorAll(".sidenav");
    var instances = M.Sidenav.init(elems, { edge: "left" });
  }, []);

  const linksModelos = () => {
    var links = props.modelos.map((modelo, i) => {
      return (
        <ul key={i}>
          <li className="waves-effect" key={i}>
            <Link
              className="waves-effect sidenav-close"
              onClick={scrollTop}
              key={i}
              to={"/" + modelo.modelo}
            >
              {modelo.modelo}
            </Link>
          </li>
        </ul>
      );
    });
    return links;
  };

  const scrollTop = () => {
    window.scroll({
      top: 0,
    });
  };

  return (
    <div>
      <div className="NavMobile">
        <ul id="slide-out" className="sidenav">
          <li>
            <div className="user-view">
              <div className="background">
                <img
                  className="fondoMobile"
                  src="images/fondos/fondoSide.jpg"
                  alt="background mobile"
                />
              </div>
              {/*<a href="https://www.toyota.com.ar/" title="Toyota Argentina" target="_blank">*/}
              <img
                className="toyotaLogoMobile"
                src="images/logos/toyotaLogo.svg"
                alt="Toyota logo mobile"
              />
              {/*</a>*/}
            </div>
          </li>
          <li>
            <Link to="/" className="sidenav-close">
              ¿AUTOS EN STOCK?
            </Link>
          </li>
          <li>
            <a className="modal-trigger" data-target="modal-video">
              ¿COMO COMPRAR?
            </a>
          </li>
          <li>
            <div className="divider"></div>
          </li>
          {linksModelos()}
          <ul>
            <li>
              <Link className="waves-effect" to="/">
                CONTACTO
              </Link>
            </li>
          </ul>
        </ul>
        <div className="navbar-fixed">
          <nav className="black">
            <a data-target="slide-out" className="sidenav-trigger">
              <i className="material-icons white-text">menu</i>
            </a>
            <Link to="/">
              <img
                className="pranaLogoMobile"
                src="images/logos/pranaLogo.png"
              />
            </Link>
          </nav>
        </div>
      </div>

      <img
        className="responsive-img NavDesktopSec"
        src="images/fondos/fondoSecundario.png"
        alt="fondoSecundario"
      />
      <img
        className="ceroVueltasLogo"
        src="images/logos/cero-vueltas.png"
        alt="logo 0km 0 vueltas"
      />

      <div className="contenedorHeaderSecundario">
        <span className="navHomeVideoSecundario">
          <Link to="/" style={{ color: "white" }}>
            AUTOS EN STOCK
          </Link>
          <span style={{ color: "white" }}>
            &nbsp; &nbsp; &nbsp; | &nbsp; &nbsp; &nbsp;
          </span>

          <Link
            className="modal-trigger"
            data-target="modal-video"
            onClick={() => props.handleMostrarModal(true)}
            style={{ color: "white" }}
          >
            {" "}
            ¿COMO COMPRAR?
          </Link>
        </span>
        <Link to="/" className="linkPranaHome"></Link>
        <a
          href="https://www.toyota.com.ar/"
          title="Toyota Argentina"
          target="_blank"
          className="linkToyotaWeb"
        ></a>
      </div>
    </div>
  );
}
